// src/utils/exportData.js

/**
 * Export data as CSV file
 * @param {Array} data - Array of objects to export
 * @param {String} filename - Name of the file (without extension)
 */
export function exportToCSV(data, filename = 'export') {
    if (!data || !data.length) {
      console.warn('No data to export');
      return;
    }
  
    // Extract headers
    const headers = Object.keys(data[0]);
  
    // Convert data to CSV string
    const csvRows = [
      headers.join(','), // header row
      ...data.map(row =>
        headers.map(field => {
          let val = row[field] === null || row[field] === undefined ? '' : row[field];
          // Escape double quotes
          val = val.toString().replace(/"/g, '""');
          // Wrap in quotes if contains comma, newline or quotes
          if (val.search(/("|,|\n)/g) >= 0) val = `"${val}"`;
          return val;
        }).join(',')
      )
    ];
  
    const csvContent = csvRows.join('\n');
  
    // Create blob and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  